package com.essntl.features.file.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.file.domain.model.FileModel
import com.essntl.features.file.ui.FileState
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.uikit.components.button.tinted.EsLargeTintedButton
import com.essntl.uikit.components.file.AttachmentCard
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberFind
import com.mohamedrejeb.calf.core.LocalPlatformContext
import com.mohamedrejeb.calf.io.getName
import com.mohamedrejeb.calf.io.getPath
import com.mohamedrejeb.calf.picker.FilePickerFileType
import com.mohamedrejeb.calf.picker.FilePickerSelectionMode
import com.mohamedrejeb.calf.picker.rememberFilePickerLauncher
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime

@Composable
fun Attachments(
    state: FileState,
    profiles: List<ProfileModel>,
    currentProfile: ProfileModel?,
    onAddAttachments: (List<FileModel>) -> Unit,
    onDeleteAttachment: (Int) -> Unit,
) {
    val context = LocalPlatformContext.current

    val pickerLauncher = rememberFilePickerLauncher(
        type = FilePickerFileType.Custom(
            listOf(
                FilePickerFileType.ImageContentType,
                FilePickerFileType.PdfContentType,
            ),
        ),
        selectionMode = FilePickerSelectionMode.Multiple,
        onResult = { files ->
            val attachments = files.map {
                FileModel.empty.copy(
                    url = it.getPath(context) ?: "",
                    name = it.getName(context) ?: "",
                    kmpFile = it,
                    uploadedBy = currentProfile?.id,
                )
            }

            if (attachments.isNotEmpty())
                onAddAttachments(attachments)
        },
    )

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 1.spacing),
    ) {
        state.getAllFile.data?.let { files ->
            files.mapIndexed { index, file ->

                val uploaderProfile = rememberFind(
                    profiles,
                    file.uploadedBy ?: "",
                ) { profile -> profile.id }

                val uploadDate = file.createdAt
                    .ifEmpty {
                        Clock.System.now().toLocalDateTime(TimeZone.UTC).date.toString()
                    }

                AttachmentCard(
                    file = file,
                    description = currentProfile?.let {
                        "Uploaded by ${uploaderProfile?.prettyName ?: it.prettyName}, on "
                    },
                    date = uploadDate,
                    onDelete = {
                        onDeleteAttachment(index)
                    },
                )
                Spacer(modifier = Modifier.height(1.spacing))
            }
        }

        Spacer(modifier = Modifier.height(1.spacing))

        EsLargeTintedButton(
            onClick = {
                pickerLauncher.launch()
            },
            text = "Upload files",
            prefixIconRes = EsIcons.Add,
            enabled = true,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}